export type PortalDomainOrg = {
  /** E.g. `blue.dev.portal.closesimple.com` */
  PortalDomainName: string // pk
  PortalDomainOrgId: string // Added later to tie a PortalRoleMapping record to an PortalDomainOrg.
  LogoUrl: string
  Auth0OrganizationId: string
  SecondaryColor: string
  CompanyId: string
  PrimaryColor: string
  CompanyDisplayName: string
  NotificationProcessId: string
  MfaRequired?: PortalMfaValues
  FileUploads?: PortalFileUploadValues
  FormsEnabled?: boolean
  IndependentSteps: PortalIndependentSteps
  UiConfig?: PortalOrgUiConfig
  SmsOptInRequired?: boolean
  ESignProvider?: ESignProvider
  SignedDocumentRemitType?: PortalSignedDocumentRemitTypes
  ShouldSubmitIdVersePdf?: boolean
  ShouldUseNewFilenameForUpload?: boolean
  FourTierRegistrationCode?: string
  Plaid?: PlaidSettings
  SaveInProgressForms?: SaveInProgressFormsEnum
  DisablePortalUserTaskCancellation?: boolean
  AccessGroupsEnabled?: boolean

  // one off manually added in dynamo
  AllowEmailMfa?: string
  UseNewOrderList?: boolean
}

export enum SaveInProgressFormsEnum {
  Disabled = 0,
  Enabled = 1
}

type PlaidSettings =
  | { option: PlaidSettingsOptionEnum.Disabled }
  | { option: PlaidSettingsOptionEnum.Always; plaidSecret: string; plaidClientId: string }
  | { option: PlaidSettingsOptionEnum.Standard; plaidSecret: string; plaidClientId: string }

export enum PlaidSettingsOptionEnum {
  Disabled = 0,
  Always = 1,
  Standard = 2,
}

export const portalSignedDocumentRemitTypes = ['multiple-pdfs', 'combined-pdf'] as const

export type PortalSignedDocumentRemitTypes = (typeof portalSignedDocumentRemitTypes)[number]

export const eSignProviders = ['DocuSign', 'DropboxSign'] as const

export type ESignProvider = (typeof eSignProviders)[number]

export const portalFileUploadValues = ['disabled', 'enabled'] as const

export type PortalFileUploadValues = (typeof portalFileUploadValues)[number]

export type PortalIndependentSteps = {
  PortalInviteStepId: string
  PortalSigningCompleteStepId: string
  PortalSigningNeededStepId: string
  PortalTaskReminderStepId: string
  PortalUploadNotificationStepId: string
  PortalSigningFailureCustomerNotificationStepId: string
  PortalUserSigningNeededStepId: string
  PortalAccountExistsStepId: string
  PortalTaskCreatedStepId: string
  PortalAdHocDocumentMessageStepId: string
  PortalPaymentUpdateStepId: string
  PortalNotificationEventMessageStepId: string
  PortalPayoffVerificationStepId: string
  PortalLiveLookUpdateStepId: string
}

export const portalMfaValues = ['disabled', 'once-restricted', 'always'] as const

export type PortalMfaValues = (typeof portalMfaValues)[number]

export type OrderRequestSendToOption = {
  id: string
  name: string
}

export type PortalOrgUiConfig = {
  Content?: PortalOrgUiConfigContent;
  Sections?: PortalOrgUiConfigSections;
  Links?: PortalOrgUiConfigLink[]
  OrderRequestSendToOptions?: OrderRequestSendToOption[]
}

export type PortalOrgUiConfigContent = {
  ClosingText?: string;
}

export type PortalOrgUiConfigSections = {
  WiringInstructions?: PortalOrgUiConfigSection;
  ClosingDetails?: PortalOrgUiConfigSection;
  ClosingContacts?: PortalOrgUiConfigSection;
  ClosingDocuments?: PortalOrgUiConfigSection;
  Tracker?: PortalOrgUiConfigSection;
  Tasks?: PortalOrgUiConfigSection;
  Messages?: PortalOrgUiConfigSection;
  [key: string]: PortalOrgUiConfigSection | undefined;
}


export type PortalOrgUiConfigSection = {
  Title?: string;
  Enabled?: boolean;
  SortOrder?: number;
  ContentToken?: string;
  Roles?: string[];
  DisplayType?: 'individualPage' | 'closingPage';
  Icon?: { value: string, label: string };
}

export type PortalOrgUiConfigLink = {
  icon?: { label: string; value: string }
  label: string
  roles?: string[]
  type: 'iframe' | 'external'
  url: string
}

export type PortalIndependentsSteps = {
  PortalInviteStepId: string;
  PortalSigningCompleteStepId: string;
  PortalSigningNeededStepId: string;
  PortalTaskReminderStepId: string;
  PortalUploadNotificationStepId: string;
}

export const portalDomainOrgFileUploadValues = [
  'disabled',
  'enabled',
]

export type PortalDomainOrgFileUploadValues = typeof portalDomainOrgFileUploadValues[number]
